import React from 'react';
import { formatTotalPrice, formatName, formatPath, formatNumberStandard } from '../../utils/helpers.js';
import { TopPage, NameCell } from './TopPage';
import PATHS from '../../utils/paths.js';
import CustomChip from '../../components/CustomChip.tsx';
import { useChartDates } from './hooks/useChartDates.ts';
const showAvatar = true;

const columns = [
  {
    field: 'id',
    headerName: 'Rank',
    width: 80,
    sortable: true,
  },
  {
    field: 'name',
    headerName: 'Brand',
    flex: 2,
    renderCell: (params) => {
      const href = params.row.date 
        ? `/brand/${formatPath(params.value)}?date=${params.row.date}`
        : `/brand/${formatPath(params.value)}`;
      return (
        <NameCell name={formatName(params.value)} href={href} />
      );
    },
    sortable: true,
  },
  {
    field: 'totalPrice',
    headerName: 'Sales',
    type: 'number',
    flex: 2,
    valueFormatter: ({ value }) => formatTotalPrice(value),
    sortable: true,
  },
  {
    field: 'soldItemsCount',
    headerName: 'Items Sold',
    type: 'number',
    flex: 2,
    true: ({ value }) => formatNumberStandard(value),
    sortable: true,
  },
  {
    field: 'averageSalePrice',
    headerName: 'Average Price',
    type: 'number',
    flex: 2,
    valueFormatter: ({ value }) => formatTotalPrice(value),
    sortable: true,
  },
  {
    field: 'categories',
    headerName: 'Top Categories',
    sortable: false,
    flex: 4,
    renderCell: (params) => (
      <div>
        {params.value
          .slice(0, 3)
          .map((category, index) => (
            <CustomChip
              key={index}
              showAvatar={showAvatar}
              name={formatName(category.name)}
              count={category.quantity}
              index={index}
            />
          ))}
      </div>
    ),
  },
];

const TopBrands = () => {
  const dates = useChartDates('brands');

  return (
    <TopPage
      type={"brands"}
      columns={columns}
      title={"The 100 Best Selling Brands on Poshmark"}
      description={"Curious about what's trending? Use this resource to help you source top-selling high value items for your Poshmark closet to boost your sales."}
      href={PATHS.TOP_BRANDS}
      toggleOptions={[
        {
          name: 'date',
          label: 'Month',
          placeholder: 'Select a month',
          options: dates,
        },
        {
          name: 'include-luxury',
          label: 'Show Luxury Brands',
          placeholder: 'Show luxury brands',
          options: [
            { value: true, label: 'Yes' },
            { value: false, label: 'No' },
          ],
        },
      ]}
      subtitle={
        <div>
          <p>
            Insights from Poshmark sales data to help you source high demand items for your closet so you can make faster sales.
          </p>
        </div>
      }
    />
  );
};

export default TopBrands;
